module.exports = __webpack_public_path__ + "static/media/doc-3.ff4b5187.jpg";